import * as yup from 'yup'

export const societyWebsiteNameDescriptionSchema = yup
  .object({
    displayName: yup.string().required(),
    description: yup.string(),
  })
  .required()
